import { useMutation } from '@tanstack/react-query'
import { fetchAdminRandomCheckIn } from '../index'
import { FetchAdminRandomCheckInPayload } from '../types/APIRequestType'

const usePostAdminRandomCheckIn = () => {
  return useMutation({
    mutationFn: ({
      limit,
      page,
      payload,
    }: {
      limit?: number
      page?: number
      payload: FetchAdminRandomCheckInPayload
    }) => fetchAdminRandomCheckIn({ limit, page, payload }),
  })
}

export default usePostAdminRandomCheckIn
